namespace Gamification.Gamification {
    export namespace TipologieEsperienzeService {
        export const baseUrl = 'Gamification/TipologieEsperienze';

        export declare function Create(request: Serenity.SaveRequest<TipologieEsperienzeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<TipologieEsperienzeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<TipologieEsperienzeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<TipologieEsperienzeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/TipologieEsperienze/Create",
            Update = "Gamification/TipologieEsperienze/Update",
            Delete = "Gamification/TipologieEsperienze/Delete",
            Retrieve = "Gamification/TipologieEsperienze/Retrieve",
            List = "Gamification/TipologieEsperienze/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>TipologieEsperienzeService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
